import type {
  InviteToTeamMutation,
  InviteToTeamMutationVariables
} from './__generated__/InviteToTeamMutation'
import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'
import { employeeCertificateFragment } from '../fragments/EmployeeCertificateFragment'
import { employeeEducationFragment } from '../fragments/EmployeeEducationFragment'
import { employeeProfileFragment } from '../fragments/EmployeeProfileFragment'
import { employeeWorkProfileFragment } from '../fragments/EmployeeWorkProfileFragment'

const mutation: TypedDocumentNode<
  InviteToTeamMutation,
  InviteToTeamMutationVariables
> = gql`
  ${employeeCertificateFragment}
  ${employeeEducationFragment}
  ${employeeProfileFragment}
  ${employeeWorkProfileFragment}

  mutation InviteToTeamMutation($input: InviteToTeamInput!, $locale: String) {
    inviteToTeam(input: $input) {
      member {
        employee {
          createdAt
          educations {
            ...EmployeeEducationFragment
          }
          email
          employeeCertificates {
            ...EmployeeCertificateFragment
          }
          firstName
          gender
          id
          isStudent
          lastName
          lastSeenAt
          mobile
          ocrState
          preferredLanguage
          profile {
            ...EmployeeProfileFragment
          }
          ssn
          state
          updatedAt
          workProfile {
            ...EmployeeWorkProfileFragment
          }
        }
      }
    }
  }
`

export function inviteToTeamMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      InviteToTeamMutation,
      InviteToTeamMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
